import {useAlert} from "@portnet/ui";
import React from "react";
import {useSelector} from "react-redux";
import {Navigate} from "react-router";
import {LOGIN_PAGE_ROUTE} from "../../constants/routerConstants";
import {MUST_LOGIN_MESSAGE} from "../others/routerMessages";

const PrivateRoute = ({ children }) => {
  const alertDispatch = useAlert();
  const isLogged = useSelector((state) => Boolean(state.auth.login.user));
  const { hasBeenLoggedOut } = useSelector((state) => state.auth.login);
  React.useEffect(() => {
    if (!isLogged && !hasBeenLoggedOut) {
      alertDispatch("error", MUST_LOGIN_MESSAGE);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLogged, hasBeenLoggedOut]);
  return isLogged ? children : <Navigate to={LOGIN_PAGE_ROUTE} replace />;
};

export default PrivateRoute;
